import { Button, Typography } from '../../1_shared/ui';
import { ReactElement, useState } from 'react';
import styles from './SpecialistSpecialization.module.scss';
import { useNavigate } from 'react-router';
import { ISpecialistSpecializationProps } from './interfaces/ISpecialistSpecializationProps';
import { IKeyThemeOption } from '../../1_shared/config/interfaces/IKeyThemesOptions';
import { RoutePath } from '../../1_shared/config/routes';
import { worksWithNamesConfig } from './config/workWithNamesConfig';

const minSpecsToShow = 12;

const SpecialistSpecialization = ({
  spec,
  keyThemesList,
  worksWithList,
}: ISpecialistSpecializationProps): ReactElement => {
  const [openSpecialization, setOpenSpecialization] = useState(false);
  const navigate = useNavigate();
  const showingArray = keyThemesList.slice(0, minSpecsToShow);
  const arrayToShow =
    openSpecialization && keyThemesList.length > minSpecsToShow + 1
      ? keyThemesList
      : showingArray;

  /*
   * При клике на тему значение темы кладется в состояние локейшена и
   * осуществляется редирект на страницу спецов с применением фильтра ключевых тем
   * по выбранному значению темы
   */
  const onHandleClick = (selectedTheme: IKeyThemeOption) => {
    if (selectedTheme?.id) {
      navigate(RoutePath.SPECIALISTS, {
        state: { value: [`${selectedTheme.value}`] },
      });
    }
  };

  /*
Перечень "работает с" специалиста */
  const worksWith = (
    <div className={styles.worksWithWrapper}>
      {worksWithList.map(item => (
        <div key={item.id} className={styles.worksWithItem}>
          {worksWithNamesConfig[item.value]}
        </div>
      ))}
    </div>
  );

  /*
  Перечень кликабельных ключевых тем специалиста
   */
  const keyThemes = (
    <div className={styles.keyThemesWrapper}>
      {arrayToShow.map(theme => (
        <button
          key={theme.id}
          className={styles.card}
          onClick={() => onHandleClick(theme)}
        >
          {theme.label}
        </button>
      ))}
      {keyThemesList.length - 1 > minSpecsToShow && !openSpecialization && (
        <Button type="secondary" onClick={() => setOpenSpecialization(true)}>
          {`+${keyThemesList.length - minSpecsToShow}`}
        </Button>
      )}
      {openSpecialization && (
        <Button
          type="secondary"
          className={styles.btnClose}
          onClick={() => setOpenSpecialization(false)}
        >
          СВЕРНУТЬ
        </Button>
      )}
    </div>
  );

  return (
    <div className={styles.root}>
      <h2 className={styles.specializationTitle}>Специализация</h2>
      <div className={styles.cardWrapper}>
        {worksWith}
        {keyThemes}
      </div>
      <div className={styles.description}>
        <Typography>{spec?.briefAboutYourself}</Typography>
      </div>
    </div>
  );
};

export default SpecialistSpecialization;
